import { Link } from 'react-router-dom';

const Tail = () => {
    return (
        <footer className="border-top p-4">
            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between gap-2">
                <a href="https://www.pic-loud.com" className="d-flex align-items-center text-decoration-none">
                    <img src="/logo_horizontal.png" alt="Pic-Loud" style={{ width: "auto", height: "20px" }} />
                </a>

                <nav className="d-flex align-items-center gap-3">
                    <Link to="/privacy" className="text-muted text-decoration-none small fw-medium footer-link">Privacy Policy</Link>
                    <span className="text-muted small">|</span>
                    <Link to="/terms" className="text-muted text-decoration-none small fw-medium footer-link">Terms of Use</Link>
                    <span className="text-muted small">|</span>
                    <a href="mailto:contact@pic-loud.com" className="text-muted text-decoration-none small fw-medium footer-link">Contact Us</a>
                </nav>

                <p className="text-muted small mb-0">
                    &copy; {new Date().getFullYear()} Pic-Loud. All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Tail;
